import { Component, OnInit } from "@angular/core";
import { MarketingCard } from "@rubbl-marketing";

@Component({
  selector: "app-list-your-machines-we-handle",
  templateUrl: "./list-your-machines-we-handle.component.html",
  styleUrls: ["./list-your-machines-we-handle.component.scss"],
})
export class ListYourMachinesWeHandleComponent implements OnInit {
  marketingCards: MarketingCard[];

  constructor() {}

  ngOnInit(): void {
    this.marketingCards = [
      {
        title: "Premium Onboarding",
        body: "Our team of onboarding specialists will get all of your machines listed on Rubbl so you start generating revenue quickly.",
      },
      {
        title: "Managed Logistics",
        body: "Rubbl coordinates and manages all of your machines’ transportation logistics using trusted and properly insured carriers.",
      },
      {
        title: "Damage Reconciliation",
        body: "We manage the entire damage reporting and claims process, ensuring that your machines are professionally repaired.",
      },
    ];
  }
}
